/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Default_Payment_ProviderInputs */

const en_admin_settings_fields_default_payment_provider = /** @type {(inputs: Admin_Settings_Fields_Default_Payment_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Default provider`)
};

const zh_admin_settings_fields_default_payment_provider = /** @type {(inputs: Admin_Settings_Fields_Default_Payment_ProviderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`默认支付方式`)
};

/**
* | output |
* | --- |
* | "Default provider" |
*
* @param {Admin_Settings_Fields_Default_Payment_ProviderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_default_payment_provider = /** @type {((inputs?: Admin_Settings_Fields_Default_Payment_ProviderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Default_Payment_ProviderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_default_payment_provider(inputs)
	return zh_admin_settings_fields_default_payment_provider(inputs)
});
export { admin_settings_fields_default_payment_provider as "admin.settings.fields.default_payment_provider" }